import BossModal from '@components/Boss/BossModal';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect, useState } from 'react';
import { DATA_GET_STORE } from '@utils/const';
import { getLabelFallback, handleHTTPError, loadScript } from '@utils/utils';
import { useForm } from 'react-hook-form';
import * as actions from '@redux-actions/';
import { fetchPhysicalStores } from '@utils/services';
import DefaultImg from '@images/map.jpg';
import { RequestStatus } from '@interfaces/mainInterfaces';
import SearchCard from './SearchCard';
import axios, { AxiosRequestConfig } from 'axios';
import Loader from '@components/Loader';
import Image from '@components/Image';


const BossApp = props => {
  const openModalBoss = useSelector((state) => state.cart.openModalBoss);
  const radius = useSelector((state) => state.cart.radius);
  const latitude = useSelector((state) => state.cart.latitude);
  const longitude = useSelector((state) => state.cart.longitude);
  const config = useSelector((state) => state.cart.config);
  const methods = useForm();
  const dispatch = useDispatch();
  const [, setEspotRequestStatus] = useState<RequestStatus>('IDLE');
  const [espot, setEspot] = useState<string>(null);
  const isMobile = useSelector(state => state.cart.isMobile);
  const [isLoadedImg, setIsLoadedImg] = useState(false);
  
  const onClose = () => {
    dispatch(actions.setOpenModalBoss(false));
    document.getElementById("content_wrapper_box").style.zIndex = '30';
    toggleLockPageScroll(false);
  };

  const hideLoader = function(){
    setIsLoadedImg(true);
  }

  const showLoader = function(){
    setIsLoadedImg(false);
  }

  const toggleLockPageScroll = lock => {
    document.querySelectorAll('html,body').forEach(elem => {
      elem.style.overflow = lock ? 'hidden' : '';
      elem.style.position = lock ? 'fixed' : '';
      elem.style.height = lock ? '100%' : '';
      elem.style.width = lock ? '100%' : '';
    });
  };

  useEffect(()=>{
    showLoader;
  }, [])

  useEffect(()=>{
    console.log('espot is: ' + isLoadedImg)
   if(!!espot){
    setIsLoadedImg(false);
   }
  }, [espot])

  useEffect(() => {
    if(!!config && !!config.bossApp && !!config.bossApp.googleApiKey && config.bossApp.googleApiKey.length > 0) {
      if (typeof window.google === 'undefined') {
        //&& typeof(window.google.maps) === 'undefined' && typeof(window.google.maps.places) === 'undefined'
        loadScript(
          `https://maps.googleapis.com/maps/api/js?key=` + config.bossApp.googleApiKey + `&libraries=places`,
          () => {
            console.log('Import google');
          }
        );
      }
    }
  }, [config]);


  /* -------------------------------------------------------
   *  CallBack che viene invocato quando viene cliccato
   *  un particolare button radio della modale per caricare
   *  le info dello store selezionato 
   * -------------------------------------------------------*/ 
  useEffect(() => {
    if (!!latitude && !!longitude) {
      fetchPhysicalStores(
        props.config.hostname,
        props.config.storeId,
        latitude,
        longitude,
        DATA_GET_STORE,
        radius
      )
        .then((res: any) => {
          if (res && res.recordSetTotal !== '0') {
            dispatch(actions.setPhysicalStores(res.PhysicalStore));
          }
        })
        .catch(err => {
          console.error(
            '>>> Error on get Stores for BOSS on change radius => error status:',
            err.status,
            ', error: ',
            err
          );
          handleHTTPError(dispatch, actions, err);
        });
    }
  }, [radius]);

  async function fetchEspot() {
    const request: AxiosRequestConfig = {
        method: 'GET',
        url: '/wcs/resources/store/{storeId}/espot/X_StoreLocator_Default_Image?nocache={noCache}'
            .replace('{storeId}', config.storeId.toString())
            .replace('{catalogId}', config.catalogId.toString())
            .replace('{noCache}', new Date().getTime().toString()),
        headers: { 'Content-Type': 'application/json' },
    };

    setEspotRequestStatus('LOADING');

    try {
        const result = await axios(request);

        const espot =
            result.data?.MarketingSpotData?.[0].baseMarketingSpotActivityData?.[0]
                .marketingContentDescription?.[0].marketingText;

        setEspotRequestStatus(!!espot ? 'SUCCESS' : 'ERROR');
        console.log('SUCCESS DEFAULT IMG ESPOT!');
        return espot;
    } catch (error) {
        setEspotRequestStatus('ERROR');
        console.log('FAILED ESPOT!');
        return [];
    }
  }

  async function downloadEspot() {
    (config?.mockRequest ? null : fetchEspot()).then(espot => setEspot(espot));
  }

  return(
    <>
      <div className="app-boss container-fluid-boss">
        <div className="app-boss-card-img-container">
          <SearchCard
            cardTitle={getLabelFallback('BOSS_TITLE_LABEL_CARD')}  
            zIndex= '1'
            config={config}
            methods={methods}
            className="app-boss-card-img-container-card" 
          />
          {(!espot && !isMobile &&
            <>
              <Image 
               src={DefaultImg}
               className="app-boss-card-img-container-image"
               width=''
               height=''
               alt='Default Map Image'
               onLoad={hideLoader}
              />
              <Loader 
               classes={"align-center-loader-default-image" + (isLoadedImg ? " hide" : " show")}
              />
            </>
          )}
        </div>
      </div>  
      {openModalBoss && (
          <BossModal onClose={onClose} config={props.config} deliverHere={{}} />
        )}
     
    </>
  );
};

export default BossApp;
